module.exports = __webpack_public_path__ + "img/提现背景图.c7c05367.png";